import Validation from '../../../common/assets/js/validation';
import ModalBindings from '../../../common/modules/modal/ModalBindings';

export default new class FormAskForCall {
    constructor() {
        /* selectors */
        this.buttonAskForCallSelector = '.js-askForCall';
        this.formDisplayedSelector = '.modal_opened .form-ask-for-call';
        this.buttonClearFormSelector = '.clear-form';
        this.formDisplayedInputsSelector = '.form__input';
        this.errorMessageSelector = '.form__requirements';
        this.modalWithFormOpenedSelector = '.modal_opened[data-modal="ask-for-call"]';
        this.modalContentSelector = '.modal__wrapper';

        this.ModalBindings = ModalBindings;
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document)
            .on('click', this.buttonAskForCallSelector, (e) => {
                e.preventDefault();

                let $form = $(this.formDisplayedSelector);

                if (!Validation.isFormValid($form)) {
                    e.preventDefault();
                    return;
                }

                $form.request('RequestCallFormIt::onRequestCall', {
                    success: () => {
                        this.resetForm();
                        this.ModalBindings.hideModal();
                    }
                });
            })
            .on('blur', 'input[required]', (e) => {
                Validation.validateInput(e.target);
            })
            .on('click', this.buttonClearFormSelector, (e) => {
                e.preventDefault();
                e.stopPropagation();

                this.resetForm();
            })
            .keyup((e) => {
                if(e.keyCode === 27) {
                    this.resetForm();
                    this.ModalBindings.hideModal();
                }
            })
            .on('click', this.modalWithFormOpenedSelector, () => {
                this.resetForm();
            })
            .on('click', this.modalContentSelector, (e) => {
                e.stopPropagation();
            });


    }

    resetForm() {
        let $form = $(this.formDisplayedSelector);

        $form[0].reset();
        $(this.formDisplayedInputsSelector).removeClass('_error');
        $(this.errorMessageSelector).css('height', 0);
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/form-ask-for-call/form-ask-for-call.js